import t from "@/lang/lang";
import { Field, FieldLabel } from "@/shared/components/ui/field";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { FieldErrors } from "@/shared/components/field/field";
import { useFieldErrors } from "@/shared/lib/errors/err-validation-failed-context";
import { ContractState } from "../types/contract";

export function ContractStateField({
  value,
  onValueChange,
  disabled,
}: {
  value: ContractState;
  onValueChange: (state: ContractState) => void;
  disabled: boolean;
}) {
  const { errors, invalid, reset } = useFieldErrors("contractState");

  // A Select cannot hold an empty value, the value of a draft.
  const draft = "draft";

  return (
    <Field data-invalid={invalid || undefined}>
      <FieldLabel>{t("Vertragsstatus")}</FieldLabel>
      <Select
        value={value || draft}
        onValueChange={(state) => {
          reset();
          onValueChange(
            state === draft ? ContractState.Draft : (state as ContractState),
          );
        }}
        disabled={disabled}
      >
        <SelectTrigger aria-invalid={invalid || undefined}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value={draft}>{t("Entwurf")}</SelectItem>
            <SelectItem value={ContractState.Signed}>
              {t("Unterschrieben")}
            </SelectItem>
          </SelectGroup>
        </SelectContent>
      </Select>
      <FieldErrors errors={errors} />
    </Field>
  );
}
